module.exports = __webpack_public_path__ + "img/DTC.b6c4dec9.png";